import { FunctionComponent, memo, useContext, Fragment } from 'react';
import classnames from 'classnames';
import Button from '@media-ui/core/src/components/Button';
import { useFormContext } from 'react-hook-form';
import { AddPetContext } from '../AddPet';
import getByPath from 'Tools/getByPath';
import { counterTrigger } from 'Tools/counters';
import { getRequiredFields } from '../stepsConfig';
import 'Styles/pets.css';
import * as s from './Footer.css';
import * as T from './Footer.types';
import { sendDataToServer } from '../utils';
import transport from '@media-ui/core/src/tools/transport';
import { pushTmr } from 'Tools/counters/pushTmr';
import { snitchCounter } from 'Tools/counters/snitchCounter';
import { PET_NAMES } from 'Tools/pets';
import removeEmptyValues from 'Tools/removeEmptyValues';
const checkEmptyObject = (obj: any) => Object.keys(obj).length === 0 && obj.constructor === Object;
const Steps: FunctionComponent<T.StepsProps> = memo(({ step }) => {
    const addPetContext = useContext(AddPetContext);
    const { isPetsshop, isEdit, isTouch, viewType } = addPetContext || {};
    const isPetsshopTouch = isPetsshop && isTouch;
    const count = isPetsshopTouch ? 2 : 3;
    const itemsCount = isEdit ? 1 : count;
    const stepsRootClasses = classnames(s.stepsRoot, {
        [s.petsshopStepsRoot]: isPetsshop,
    });
    const currentStep = isPetsshopTouch ? step - 1 : step;
    if (step === 0 && viewType === 'year2022') {
        return null;
    }
    return (<div className={stepsRootClasses}>
      <div style={{ transform: `translateX(${28 * currentStep}px)` }} className={`${s.active} ${s.item}`}/>
      {new Array(itemsCount).fill(1).map((_, i) => (<div key={i} className={s.item}/>))}
    </div>);
});
const getButtonName = (step: number, isEdit?: boolean) => {
    switch (isEdit) {
        case true:
            return step === 0 ? 'Изменить питомца' : 'Удалить';
        case false:
            return step === 2 ? 'Добавить питомца' : 'Продолжить';
    }
};
let disableNextButton = false;
const Footer: FunctionComponent<T.FooterProps> = ({ step, prev, next, isTouch, }) => {
    const isZeroStep = step === 0;
    const isFirstStep = step === 1;
    const isSecondStep = step === 2;
    const isThirdStep = step === 3;
    const { getValues, errors } = useFormContext();
    const addPetContext = useContext(AddPetContext);
    const requiredFields = getRequiredFields(addPetContext?.isAddPetPurinaRequired || false, getValues('pet'), addPetContext?.viewType || 'default');
    disableNextButton = !requiredFields[step].reduce((acc, item) => {
        const values = getValues();
        if (item === 'kind') {
            item = values['pet'] === 1 ? 'kind_dog' : 'kind_cat';
        }
        return acc && values[item];
    }, true);
    const { isEdit, mainUrl, isPetsshop, viewType } = addPetContext || {};
    const isPetsshopTouch = isTouch && isPetsshop;
    const isYear2022 = viewType === 'year2022';
    const buttonClasses = classnames(s.button, {
        [s.petsshopButton]: isPetsshop,
    });
    const buttonName = getButtonName(step, isEdit);
    const btnIsDisabled = (disableNextButton || !checkEmptyObject(errors)) &&
        buttonName !== 'Удалить';
    const onButtonClick = () => {
        return isZeroStep ? addPetContext?.hideWindow() : prev();
    };
    const getButtonOnClick = (_: any, isEdit?: boolean) => {
        const { pet, age, nick, kind_cat, user_email, birth_date } = getValues();
        const values = removeEmptyValues(getValues());
        const finalClick = async () => {
            const resp = await sendDataToServer(mainUrl || '', Object.assign(values, {
                action: isPetsshop ? 'petshopru2021' : null,
                rb_banner_id: addPetContext?.statBannerId,
            }));
            /* TODO: удалить */
            const errorMessage = resp?.message === 'fail. too many pets.'
                ? 'Нельзя добавить больше 15 питомцев.'
                : resp.message;
            if (!resp?.status) {
                addPetContext?.setContext((prevContext) => prevContext
                    ? {
                        ...prevContext,
                        isError: true,
                        errorMessage,
                    }
                    : undefined);
            }
            addPetContext?.setContext((context) => {
                if (context)
                    context.petHadChanged = true;
                return context;
            });
        };
        const tmrCounters = () => {
            const { pet, age } = getValues();
            const CAT_TYPE = 2;
            pushTmr({
                id: '2958944',
                type: 'reachGoal',
                goal: isTouch ? 'add_pets_touch' : 'add_pets_web',
            });
            pushTmr({
                id: '2958944',
                type: 'reachGoal',
                goal: pet === CAT_TYPE ? 'add_cat' : 'add_dog',
            });
            if (age === '0') {
                pushTmr({
                    id: '2958944',
                    type: 'reachGoal',
                    goal: pet === CAT_TYPE ? 'add_kitten' : 'add_puppy',
                });
            }
        };
        const infoAddParams = {
            petName: nick,
            petBreed: kind_cat,
            petAgeGroup: age,
            petBirthDate: birth_date,
        };
        if (birth_date) {
            infoAddParams.petBirthDate = birth_date;
        }
        if (!isEdit && isSecondStep) {
            snitchCounter('addPetFormInfoAdd', infoAddParams);
        }
        switch (isEdit) {
            case true:
                return isZeroStep
                    ? async () => {
                        await finalClick();
                        counterTrigger('addPetWindowChangePet');
                        snitchCounter('editPetFormPetEdit', infoAddParams);
                        addPetContext?.hideWindow();
                    }
                    : async () => {
                        const removeUrl = getByPath('remote.urls.remove', addPetContext);
                        if (removeUrl) {
                            counterTrigger('addPetWindowRemovePet');
                            snitchCounter('editPetFormPetDelete', infoAddParams);
                            await transport(removeUrl, {
                                method: 'POST',
                            });
                            window.location.reload();
                        }
                    };
            case false:
                return (viewType === 'year2022' ? isThirdStep : isSecondStep)
                    ? () => {
                        finalClick();
                        tmrCounters();
                        counterTrigger('addPetWindowAddPet');
                        next();
                        snitchCounter('addPetFormComplete', {
                            ...infoAddParams,
                            ...{
                                petType: PET_NAMES[pet as keyof typeof PET_NAMES],
                                userEmail: user_email,
                            },
                        });
                    }
                    : next;
        }
    };
    return (<div className={s.root}>
      {isPetsshopTouch && (<div className={s.buttonWrapper}>
          {(isFirstStep || isSecondStep) && <Steps step={step}/>}
          <Button disabled={btnIsDisabled} className={buttonClasses} onClick={getButtonOnClick(step, isEdit)} wide={false} theme="primary">
            {isFirstStep ? 'Далее' : 'Получить скидку'}
          </Button>
          {isZeroStep && (<Fragment>
              <hr />
              <div className={s.promoText}>
                *Промокод на скидку 15% применяется на всю продукцию брендов
                Purina и действителен с 1 сентября по 30 октября 2021 года.
                Минимальная сумма заказа — 200 рублей, максимальная — 3 000
                рублей. Количество промокодов ограничено.
              </div>
            </Fragment>)}
        </div>)}
      {!isPetsshopTouch && !(isYear2022 && (step === 0 || step === 1)) && (<Fragment>
          <div className={s.buttonWrapper}>
            <Button className={s.button} onClick={onButtonClick}>
              {isZeroStep ? 'Отменить' : 'Назад'}
            </Button>
          </div>
          <Steps step={isYear2022 ? step - 1 : step}/>
          <div className={s.buttonWrapper}>
            <Button disabled={buttonName === 'Удалить' ? false : btnIsDisabled} className={buttonClasses} onClick={getButtonOnClick(step, isEdit)} theme="primary">
              {buttonName}
            </Button>
          </div>
        </Fragment>)}
      {isYear2022 && step === 1 && (<Fragment>
          <div className={s.buttonWrapperWide}>
            <Button disabled={btnIsDisabled} className={buttonClasses} onClick={getButtonOnClick(step, isEdit)} theme="primary" wide>
              Добавить
            </Button>
          </div>
          <div className={s.buttonWrapperWide}>
            <Button className={s.button} onClick={() => addPetContext?.hideWindow()} wide>
              Закрыть
            </Button>
          </div>
        </Fragment>)}
      {isYear2022 && step === 0 && (<Fragment>
          <div className={s.buttonWrapperCenter}>
            <Button className={buttonClasses} onClick={getButtonOnClick(step, isEdit)} theme="primary">
              Продолжить
            </Button>
          </div>
        </Fragment>)}
    </div>);
};
export default Footer;
